/**
 * Gate for the multi-format export experience: selecting several file formats in one submission and
 * getting a separate history row and download link for each. When off, the export form is the
 * current single-select experience. Shared with the server-side gate on the export endpoint.
 */
import { useFeatureFlagEnabled } from '@posthog/react';
export const EXPORT_MULTI_FORMAT_FLAG = 'export-multi-format-enabled';

export function useExportMultiFormatEnabled(): boolean {
  return useFeatureFlagEnabled(EXPORT_MULTI_FORMAT_FLAG) === true;
}
